<template>
  <div class="sectionBox">
    <div class="legendBox">
      <img src="../../assets/centre1.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "centre",
  data() {
    return {
    };
  },
  created() {
    document.title = 'Privilege Centre';
  },
  methods: {
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.legendBox{
  width: 6.4rem;
}

.legendBox img{
    display: block;
    width: 6.4rem;
  }
</style>
